import { funnel } from "remeda";

export const debounce = <Args extends unknown[]>(
  func: (...args: Args) => void,
  wait = 0
) => {
  const { call, cancel, flush } = funnel<Args, Args>(
    (args) => {
      func(...args);
    },
    {
      minQuietPeriodMs: wait,
      reducer: (_, ...args) => args,
      triggerAt: "end"
    }
  );

  return Object.assign(call, { cancel, flush });
};
